export default __webpack_public_path__ + "img/fair_housing_icon.acc6a8f5.svg";